import * as actionTypes from './actionTypes';

export const onGetConsentsPdf = (path) => {
    return {
        type: actionTypes.GET_CONSENTS_PDF,
        path,
    };
};
